export default "__VITE_ASSET__BrJvUZTD__"